import { Link as MaterialLink, Typography } from "@mui/material"

const Link = ({ 
    url = "",
    label = "",
    size = "1.0rem",
    margin = 0,
    padding = 1,
    style = {
      "color": "black",
      "textDecoration": "none",
    },
    hover = {
      color: "black",
      backgroundColor: "#00000015",
      cursor: "crosshair",
      textDecoration: "none"
    }
  }) => {

  style["&:hover"] = hover

  return(
    <MaterialLink 
      href = {url}
      ml = {margin}
      mr = {margin}
      pl = {padding} 
      pr = {padding}
      sx = {style}
    >
      <Typography color="inherit" fontSize={size}>
        {label}
      </Typography>
  </MaterialLink>
  )
}

export default Link